import { render, staticRenderFns } from "./RssPublishDate.vue?vue&type=template&id=5eb6032e"
import script from "./RssPublishDate.vue?vue&type=script&lang=ts"
export * from "./RssPublishDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports